<div class="video-profile-selector">
  <div
    *ngIf="!canAdd"
    class="video-profile-selector__errors">
    These settings are not registered for this environment, so a profile cannot
    be applied:
    <div *ngFor="let name of unregisteredTargets">• {{ name }}</div>
  </div>

  <div class="video-profile-selector__hint">
    Sets Video Encoder Control and Video Source Control for the Exterior and
    Interior cameras.
  </div>

  <div class="lx-label">Select Profile</div>
  <div class="video-profile-selector__options">
    <label
      *ngFor="let p of profiles"
      class="video-profile-selector__option"
      [class.selected]="selectedId === p.id"
      [for]="'profile-' + p.id">
      <input
        type="radio"
        name="videoProfile"
        [id]="'profile-' + p.id"
        [value]="p.id"
        [checked]="selectedId === p.id"
        [disabled]="unpin"
        (change)="select(p.id)" />
      <div class="video-profile-selector__option__content">
        <span class="video-profile-selector__option__title">{{ p.label }}</span>
        <span class="video-profile-selector__option__desc">{{ p.description }}</span>

        <div
          *ngIf="selectedId === p.id"
          class="video-profile-selector__details">
          <div class="video-profile-selector__details__group">Video Encoder Control</div>
          <div class="video-profile-selector__details__row">
            <span class="video-profile-selector__details__label">Exterior:</span>
            <span class="video-profile-selector__details__code">{{ p.encoderExterior }}</span>
          </div>
          <div class="video-profile-selector__details__row">
            <span class="video-profile-selector__details__label">Interior:</span>
            <span class="video-profile-selector__details__code">{{ p.encoderInterior }}</span>
          </div>
          <div class="video-profile-selector__details__group">Video Source Control</div>
          <div class="video-profile-selector__details__row">
            <span class="video-profile-selector__details__label">Exterior:</span>
            <span class="video-profile-selector__details__code">{{ p.sourceExterior }}</span>
          </div>
          <div class="video-profile-selector__details__row">
            <span class="video-profile-selector__details__label">Interior:</span>
            <span class="video-profile-selector__details__code">{{ p.sourceInterior }}</span>
          </div>
        </div>
      </div>
    </label>

    <label
      class="video-profile-selector__option"
      [class.selected]="isCustom"
      for="profile-custom">
      <input
        type="radio"
        name="videoProfile"
        id="profile-custom"
        [value]="customId"
        [checked]="isCustom"
        [disabled]="unpin"
        (change)="select(customId)" />
      <span class="video-profile-selector__option__content">
        <span class="video-profile-selector__option__title">Custom</span>
        <span class="video-profile-selector__option__desc">
          Specify encoder and source settings manually
        </span>
      </span>
    </label>
  </div>

  <div
    *ngIf="isCustom"
    class="video-profile-selector__custom">
    <div class="video-profile-selector__custom__group">
      <div class="lx-label">Custom Video Encoder Settings</div>
      <label class="video-profile-selector__sublabel">Video Encoder Control - SF400 - Exterior</label>
      <input
        class="video-profile-selector__mono"
        type="text"
        [(ngModel)]="custom.encoderExterior"
        [disabled]="unpin"
        (ngModelChange)="onCustomChange()" />
      <label class="video-profile-selector__sublabel">Video Encoder Control - SF400 - Interior</label>
      <input
        class="video-profile-selector__mono"
        type="text"
        [(ngModel)]="custom.encoderInterior"
        [disabled]="unpin"
        (ngModelChange)="onCustomChange()" />
      <div class="video-profile-selector__format">
        Format: ENCODER=0|1, RES=0|1|2, FPS=10|20, BITRATE=value in Kbps
      </div>
    </div>

    <div class="video-profile-selector__custom__group">
      <div class="lx-label">Custom Video Source Settings</div>
      <label class="video-profile-selector__sublabel">Video Source Control - SF400 - Exterior</label>
      <input
        class="video-profile-selector__mono"
        type="text"
        [(ngModel)]="custom.sourceExterior"
        [disabled]="unpin"
        (ngModelChange)="onCustomChange()" />
      <label class="video-profile-selector__sublabel">Video Source Control - SF400 - Interior</label>
      <input
        class="video-profile-selector__mono"
        type="text"
        [(ngModel)]="custom.sourceInterior"
        [disabled]="unpin"
        (ngModelChange)="onCustomChange()" />
      <div class="video-profile-selector__format">Format: RES=0|1|2, FPS=10|20</div>
    </div>
  </div>

  <label class="video-profile-selector__unpin">
    <input
      type="checkbox"
      [(ngModel)]="unpin"
      (ngModelChange)="onUnpinChange()" />
    <span class="video-profile-selector__unpin__label">Unpin Value</span>
  </label>

  <div class="video-profile-selector__preview">
    <div class="lx-label">Preview</div>

    <div class="video-profile-selector__preview__group">Video Encoder Control</div>
    <div class="video-profile-selector__preview__row">
      <span class="video-profile-selector__preview__label">Exterior</span>
      <span class="video-profile-selector__preview__value">{{ previewValues.encoderExterior }}</span>
    </div>
    <div class="video-profile-selector__preview__row">
      <span class="video-profile-selector__preview__label">Interior</span>
      <span class="video-profile-selector__preview__value">{{ previewValues.encoderInterior }}</span>
    </div>

    <div class="video-profile-selector__preview__group">Video Source Control</div>
    <div class="video-profile-selector__preview__row">
      <span class="video-profile-selector__preview__label">Exterior</span>
      <span class="video-profile-selector__preview__value">{{ previewValues.sourceExterior }}</span>
    </div>
    <div class="video-profile-selector__preview__row">
      <span class="video-profile-selector__preview__label">Interior</span>
      <span class="video-profile-selector__preview__value">{{ previewValues.sourceInterior }}</span>
    </div>
  </div>
</div>
